import React, { createContext, useContext, useState } from 'react';

import { type SharingModalProps, SharingModal } from '#src/app/pages/starterDashboardV2/shared/components';

type SharingProps = Omit<SharingModalProps, 'defaultOpen'>;

type SharingModalContextType = {
	startSharingFlow: (props: SharingProps) => void;
	stopSharingFlow: () => void;
};

const SharingModalContext = createContext<SharingModalContextType>({
	startSharingFlow: (_props: SharingProps) => {},
	stopSharingFlow: () => {},
});

export const useSharingModal = () => useContext(SharingModalContext);

export const SharingModalProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
	const [sharingModalProps, setSharingModalProps] = useState<SharingModalProps | null>(null);
	const [modalKey, setModalKey] = useState(0);

	const startSharingFlow = (props: SharingProps) => {
		setModalKey((prev) => prev + 1);
		setSharingModalProps({ ...props, defaultOpen: true });
	};

	const stopSharingFlow = () => {
		setSharingModalProps(null);
	};

	return (
		<SharingModalContext.Provider value={{ startSharingFlow, stopSharingFlow }} data-testid="sharing-modal-context">
			{children}
			{sharingModalProps && <SharingModal key={modalKey} {...sharingModalProps} onClose={stopSharingFlow} />}
		</SharingModalContext.Provider>
	);
};
